export class Prospecto {
    /**Nombre */
    nombre: string = "";
    /**Correo */
    correo: string = "";
    /**Sexo */
    sexo: number = 1;
    /**Código postal */
    cp: string = "";
    /**Estado */
    estado: string = "";
    /**Municipio */
    municipio: string = "";
    /**Contraseña */
    contrasena?: string = '';
    /**Confirmar */
    confirmar?: string = '';
    /**Usuario Logeado */
    logeado?: boolean = false;
    /**ProspectoId */
    prospectoId?: number;
}